import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_LIST_ITEMS_START, PUT_LIST_ITEMS_ERROR, PUT_LIST_ITEMS_START, PUT_LIST_ITEMS_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/list-items/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_LIST_ITEMS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_LIST_ITEMS_ERROR, error });
  } finally {
    yield put({ type: GET_LIST_ITEMS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_list_items() {
  yield takeLatest(PUT_LIST_ITEMS_START, edit);
}


